export type Theme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'tpct-theme';
export const THEME_ATTR = 'data-theme';

export const readStoredTheme = (): Theme => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') {
      return stored;
    }
  } catch {
    // localStorage unavailable
  }
  return 'light';
};

export const applyTheme = (theme: Theme): void => {
  document.documentElement.setAttribute(THEME_ATTR, theme);
};

export const initThemeFromStorage = (): Theme => {
  const theme = readStoredTheme();
  applyTheme(theme);
  return theme;
};

export const persistTheme = (theme: Theme): void => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // localStorage unavailable
  }
};
